import styled from 'styled-components';

export const SetbacksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
	magin-top:8px;
	padding: 10px 6px;
	height: 100%
`;

export const Label = styled.h4`
	margin-top: 8px;
	font-size: 1.15rem;
	font-weight: 500;
	margin-bottom:0;
	color: var(--textColor);
`;

export const SetbackItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
	gap: 3px;
	flex-direction: column;
	flex: 0 0 calc(33.333% - 50px);
	@media (max-width: 500px){
		flex: 0 0 calc(50% - 20px);
	}
`;

export const SetbackInputWithLabel = styled.div`
  display: flex;
	flex-direction: column;
  justify-content: flex-start;
	align-items: flex-start;
	gap: 4px;
	
`;

export const SetbackLabel = styled.span`
	font-weight: 600;
	// min-width:130px;
	font-size: .85rem;
	color: var(--textColor);
`;

export const SetbackInput = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
  align-items: center;
	width 100%;
	// max-width:86%;

	input{
	line-height:1.35;
	width:104px;
	font-size:.85rem;
	 padding: 6px 0px 6px 10px;
	 background: var(--defaultBgLightColor);
	 color: var(--textColor);

	 &.input-error{
	 	border-color: var(--inputErrorBorderColor);
 		background: var(--inputErrorBgColor);
		color: var(--inputErrorTextColor);
	 }
	}
	 &::-webkit-inner-spin-button {
    width: 14px;
    height: 40px;
}
`;

export const SetbackUnit = styled.span`
  	margin-left: 4px;
	color: var(--subHeadingColor);
    font-weight: 500;
    font-size: 0.85rem;
    padding: 6px 2px;
    /* background: rgba(174, 174, 174, 0.21); */
    /* border-radius: 2px; */
    opacity: .65;
`;
export const DivGrid = styled.div`
		// display: grid;
    // grid-template-columns: repeat(3, 1fr);
	display:flex;
	justify-content: space-between;
	flex-wrap: wrap;
  gap: 20px 18px;
	@media (max-width: 500px){
		justify-content: flex-start;
	}
`;
export const DivError = styled.div`
		display: flex;
    justify-content:center;
`;
export const SetbackError = styled.span`
	color: oklch(0.61 0.27 29.61);
	font-weight:400;
	font-size:0.825rem;
	margin-top: 3px;
`;